import { AgGridReact } from 'ag-grid-react';

/**
 * Default grid search for the search icon in the ComposedViewAgGrid.
 */
const searchGrid = (grid: AgGridReact, filterString: string) => {
  // should have logic in here handling errors but need direction from UX
  grid.api.setQuickFilter(filterString);
};
export default searchGrid;
